import attributeService from "../../services/attributeSertvice";
import {
    ATTRIBUTE_GET_FAILURE,
    ATTRIBUTE_GET_REQUEST,
    ATTRIBUTE_GET_SUCCESS,
     } from "./actionTypes";
export const fetchAttributeAction = (authUserId,token,isOnlyVariant,isGroupValue) => {

    return async (dispatch) => {
      dispatch({ type: ATTRIBUTE_GET_REQUEST });
      try {
        const response = await attributeService.fetchAttribute(authUserId,token,isOnlyVariant,isGroupValue);
        const payload = Array.isArray(response)
          ? response
          : response?.data ?? [];
        dispatch({ type: ATTRIBUTE_GET_SUCCESS, payload });
        return payload; 
      } catch (error) {
        dispatch({ type: ATTRIBUTE_GET_FAILURE, payload: error.message });
        return Promise.reject(error); 
      }
    };
  };